import { EMPTY_OBJ, EMPTY_ARR } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useLanguagesList = (queryVariables = {}, queryConfig = {}) => {
  const { data: languages = [], ...queryResult } = useResourceList(
    { name: 'languages', api: api.languages },
    queryVariables,
    queryConfig,
  );

  return {
    languages,
    latestLanguages: queryResult.latestData,
    ...queryResult,
  };
};

export const useLanguage = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['language', { id }], api.languages.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    language: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const useLanguageByCode = ({ code }, queryConfig = {}) => {
  const queryResult = useQuery(['language', { code }], api.languages.getByCode, {
    ...queryConfig,
  });

  return {
    language: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const useLanguageByCodes = ({ codes }, queryConfig = {}) => {
  const queryResult = useQuery(['articles', { codes }], api.languages.getByCodes, {
    ...queryConfig,
    enabled: codes?.length > 0,
  });

  return {
    languages: queryResult.data || EMPTY_ARR,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'languages' });

export const useDeleteLanguage = createMutation(api.languages.remove);

export const useCreateLanguage = createMutation(api.languages.create);

export const useSaveLanguage = createMutation(api.languages.save);

export const useUpdateLanguage = createMutation(api.languages.update);
